import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = {
  class: "delete-popup offcanvas offcanvas-end border-0",
  tabindex: "-1",
  id: "deletePopup"
}
const _hoisted_3 = { class: "offcanvas-body p-0" }
const _hoisted_4 = { class: "delete-success" }
const _hoisted_5 = { class: "text-white fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_FilterContent = _resolveComponent("FilterContent")!
  const _component_ExpensesList = _resolveComponent("ExpensesList")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_DetailsModal = _resolveComponent("DetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "expense_list" }),
      _createVNode(_component_FilterContent, {
        btnText: "expenses",
        btnLink: "/create-expense",
        onFilter: _ctx.handleFilter,
        onExportExcel: _ctx.handleExport
      }, null, 8, ["onFilter", "onExportExcel"]),
      _createVNode(_component_ExpensesList, {
        ref: "expensesListRef",
        "search-query": _ctx.searchQuery,
        filters: _ctx.filters,
        onViewDetails: _ctx.openDetailsModal
      }, null, 8, ["search-query", "filters", "onViewDetails"]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Image"
          }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("expense_page.expense_deleted_from_list")), 1)
        ])
      ])
    ]),
    _createVNode(_component_DetailsModal, { expense: _ctx.selectedExpense }, null, 8, ["expense"])
  ], 64))
}